<template>
  <div class="stripe-element" :class="{'is-focused': isFocused}">
    <div></div>
  </div>
</template>

<style lang="scss">
  @import '../../styles/quasar.variables';

  .stripe-element {
    border: 1px solid rgba(0, 0, 0, 0.24);
    border-radius: 4px;
    padding: 19px 12px;
    transition: all 0.5s;
    &.is-focused {
      padding: 18px 11px;
      border: 2px solid $primary;
      transition: all 0.5s;
    }
  }
</style>

<script>
import { createElement } from './stripe';

export default {
  emits: ['change', 'mounted'],
  props: {
    type: {
      type: String,
      required: true,
    },
    placeholder: String,
  },
  data() {
    return {
      element: null,
      isFocused: false,
    };
  },
  mounted() {
    this.element = createElement(this.type, this.placeholder);
    this.element.mount(this.$el.querySelector('div'));
    this.$emit('mounted', this.element);
    this.element.on('focus', () => {
      this.isFocused = true;
    });
    this.element.on('blur', () => {
      this.isFocused = false;
    });
    this.element.on('change', (event) => {
      this.$emit('change', event);
    });
  },
  beforeUnmount() {
    this.element.destroy();
  },
};
</script>
